import useTitleTranslate from "@hooks/useTitleTranslate";
import { Modal, Select } from "antd";
import { Trans } from "react-i18next";
import { IconArrowDown, IconRight } from "@icons/index";
import Image from "@components/Image";
import { formatImgUrl } from "@utils/format";
import { FULL_SERVICE } from "@config";
import { useEffect, useState } from "react";
import commonservice from "@apis/commonservice";
import CopyBtn from "@components/CopyBtn";
import { useAppSelector } from "@hooks/redux";
import VideoCover from "@layouts/VideoCover";
import classNames from "classnames";

const TitleTranslateModal = ({ open }: { open: boolean }) => {
  const { language } = useAppSelector((state) => state.globalReducer);
  const { setShowTranslateModal, translateResourceInfo, setTranslateResourceInfo } = useTitleTranslate();
  const [targetLanguage, setTargetLanguage] = useState<string>(language);
  const [translateResult, setTranslateResult] = useState<string>("");
  const [disableCopy, setDisableCopy] = useState<boolean>(false);
  useEffect(() => {
    if (translateResourceInfo && open) {
      commonservice
        .getTitleTranslate({
          text: translateResourceInfo.product_title || translateResourceInfo.video_title,
          to: targetLanguage,
        })
        .then((res) => {
          setTranslateResult(res);
          if (res === "Translation failed") {
            setDisableCopy(true);
          }
        })
        .catch(() => {
          setTranslateResult("Translation failed");
          setDisableCopy(true);
        });
    }
  }, [targetLanguage]);
  const handleImg = () => {
    if (translateResourceInfo.type === "product" && translateResourceInfo.id) {
      return (
        <Image
          className="w-[72px] h-[72px]"
          url={formatImgUrl("product", translateResourceInfo.id)}
          hoverEnlarge={true}
          isFullService={translateResourceInfo.is_full_service === FULL_SERVICE}
        ></Image>
      );
    } else if (translateResourceInfo.type === "video" && translateResourceInfo.videoId) {
      return (
        <VideoCover
          className="w-[72px] h-[96px] rounded-[6px]"
          videoId={translateResourceInfo.videoId}
          hoverEnlarge={false}
          isVideo={false}
        ></VideoCover>
      );
    } else {
      return <div className="w-[72px] h-[72px] bg-[#EEE] rounded-[6px]"></div>;
    }
  };
  if (language !== "zh-CN" && language !== "en-US") return null;
  return (
    <Modal
      open={open}
      width={560}
      centered={true}
      mask={{ closable: true }}
      onCancel={() => setShowTranslateModal(false)}
      title={
        <div className="flex items-center justify-between">
          <div className="flex items-center flex-start gap-[10px] ">
            <div>
              <Trans>Translate</Trans>
            </div>
            <Select
              value={targetLanguage}
              onChange={(value) => {
                setTargetLanguage(value);
              }}
              className="w-[141px]"
              popupClassName="w-[188px] select-option-down-style"
              popupMatchSelectWidth={false}
              suffixIcon={<IconArrowDown className="w-[16px] h-[16px] text-kds-fg-subtle" />}
              menuItemSelectedIcon={<IconRight />}
              options={[
                { value: "zh-CN", label: "中文(简体)" },
                { value: "en-US", label: "English(US)" },
              ]}
            />
          </div>
        </div>
      }
      afterClose={() => {
        setTranslateResourceInfo(null);
        setDisableCopy(false);
      }}
      footer={null}
    >
      <div className="flex flex-col gap-[16px] ">
        <div className="flex items-start gap-[10px] border-t border-kds-border pt-[16px]">
          {handleImg()}
          <div className="flex-1 leading-[24px] ">
            {translateResourceInfo?.product_title || translateResourceInfo?.video_title}
          </div>
        </div>
        <div className="w-full p-[8px] border border-kds-border rounded-[4px] flex flex-start  justify-between ">
          <div
            className={classNames({
              "text-first": disableCopy,
            })}
          >
            {translateResult}
          </div>
          <div className=" ">
            <CopyBtn disable={disableCopy} text={translateResult} pos="title-translate-modal-copy" />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default TitleTranslateModal;
